import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../lib/firebase/config';

const NoInternetError: React.FC = () => {
  const [shouldRefresh, setShouldRefresh] = useState(false);

  useEffect(() => {
    const settingsRef = doc(db, 'settings', 'system');
    const unsubscribe = onSnapshot(settingsRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        const infraOpStatus = data.infraOpStatus || false;
        
        if (!infraOpStatus) {
          setShouldRefresh(true);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
    });

    return unsubscribe;
  }, []);

  if (shouldRefresh) {
    return (
      <div className="min-h-screen bg-dark-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-green-500 mx-auto mb-4"></div>
          <p className="text-xl text-green-400">System restored. Refreshing...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-100 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-6">
        <div className="mb-8">
          <svg className="w-24 h-24 mx-auto text-gray-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636A9 9 0 105.636 18.364" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M1 1l22 22" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-white mb-4">No Internet Connection</h1>
        <p className="text-gray-400 mb-6">
          Please check your network connection and try again. Make sure you're connected to the internet.
        </p>
        <div className="space-y-3 text-sm text-gray-500">
          <p>• Check your WiFi or ethernet connection</p>
          <p>• Try refreshing the page</p>
          <p>• Contact your network administrator if the problem persists</p>
        </div>
        <button 
          onClick={() => window.location.reload()} 
          className="mt-8 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default NoInternetError;
